module.exports = __webpack_public_path__ + "static/media/murder.802bab3c.svg";